import { mapState, mapActions } from "vuex"
import {
  deleteXPCondition,
  activateXPCondition,
  deactivateXPCondition,
} from "@/apis/xpConditions"

export default {
  computed: {
    ...mapState("xpConditions", ["conditionsBeingActivated"]),
  },
  methods: {
    ...mapActions("xpConditions", [
      "initiateLongPooling",
      "removeConditionStatusTracking",
    ]),
    getStatusById(id) {
      return this.conditionsBeingActivated[id]
        ? this.conditionsBeingActivated[id]
        : null
    },
    isActivating(id) {
      return this.conditionsBeingActivated[id]
    },
    async deleteCondition({ id, name }) {
      const value = await this.$swal({
        text: `Are you sure you want to delete ${name}?`,
        icon: "error",
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: "Delete",
            value: true,
            className: "bg-red focus:bg-red hover:bg-red active:bg-red",
          },
        },
      })
      if (!value) return
      deleteXPCondition(id)
        .then(() => {
          this.updateTable()
          this.$noty.success(`Successfully deleted ${name}`)
          this.removeConditionStatusTracking(id)
        })
        .catch(err => {
          console.error(err)
          const msg =
            err.response && err.response.data
              ? this.$options.filters.capitalize(err.response.data.message)
              : `Failed to delete ${name}`
          this.$swal({
            text: msg,
            icon: "warning",
            buttons: "Close",
          })
        })
    },
    confirmToggle(name, actionType) {
      return this.$swal({
        text: `Are you sure you want to ${actionType} ${name}?`,
        icon: "info",
        buttons: {
          cancel: "Cancel",
          confirm: {
            text: this.$options.filters.capitalize(actionType),
            value: true,
            className:
              actionType === "activate"
                ? "bg-green hover:bg-green-dark active:bg-green-dark focus:bg-green-dark"
                : "bg-orange hover:bg-orange-dark active:bg-orange-dark focus:bg-orange-dark",
          },
        },
      })
    },
    async updateActiveStatus({ name, id, actionType }) {
      const action =
        actionType === "activate" ? activateXPCondition : deactivateXPCondition
      return action(id)
        .then(res => {
          if (actionType === "deactivate")
            this.$noty.success(`Successfully ${actionType}ed`)
          else {
            this.initiateLongPooling({
              name,
              condition_id: id,
              uuid: res.data.uuid,
            })
            this.$swal({
              icon: "success",
              text: `Started activation process for "${name}" condition. Keep this tab open to track the progress.`,
            })
          }
          return res
        })
        .catch(err => {
          if (err.response && err.response.data) {
            this.$swal({
              icon: "warning",
              text: this.$options.filters.capitalize(err.response.data.message),
            })
          } else {
            this.$noty.error(`Failed to ${actionType}. Please try again`)
          }
          throw new Error(err)
        })
    },
    updateTable() {
      this.$refs.table.getItems()
    },
    async cancel() {
      const value = await this.$swal({
        text: `Are you sure you? Your changes will not be saved!`,
        icon: "error",
        buttons: {
          cancel: "Keep Editing",
          confirm: {
            text: "Yes, Discard",
            value: true,
            className: "bg-red focus:bg-red hover:bg-red active:bg-red",
          },
        },
      })
      if (!value) return
      this.$router.go(-1)
    },
  },
}
